import React from 'react';
import { Modal } from '@common/Modal';
import { MapPin, Navigation, Signal, Wifi } from 'lucide-react';
import { useLocationTracking } from '@hooks/useLocationTracking';

export const LocationInfoModal = ({ isOpen, onClose }) => {
  const { userLocation, locationStatus, locationAccuracy } = useLocationTracking();

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Location Information">
      <div className="p-6 space-y-6">
        {/* Status */}
        <div className="bg-gray-700/50 p-4 rounded-lg">
          <div className="flex items-center gap-2 mb-2">
            <Signal className={`w-5 h-5 ${locationStatus === 'available' ? 'text-green-400' : 'text-red-400'}`} />
            <h3 className="font-medium text-white">Status</h3>
          </div>
          <p className="text-white capitalize">{locationStatus}</p>
        </div>

        {/* Current Location */}
        {userLocation && (
          <div className="bg-gray-700/50 p-4 rounded-lg">
            <div className="flex items-center gap-2 mb-4">
              <MapPin className="w-5 h-5 text-blue-400" />
              <h3 className="font-medium text-white">Current Location</h3>
            </div>
            <div className="space-y-2">
              <div className="flex justify-between text-sm">
                <span className="text-gray-400">Latitude</span>
                <span className="text-white">{userLocation.lat.toFixed(6)}</span>
              </div>
              <div className="flex justify-between text-sm">
                <span className="text-gray-400">Longitude</span>
                <span className="text-white">{userLocation.lng.toFixed(6)}</span>
              </div>
              {locationAccuracy && (
                <div className="flex justify-between text-sm">
                  <span className="text-gray-400">Accuracy</span>
                  <span className="text-white">±{Math.round(locationAccuracy)}m</span>
                </div>
              )}
            </div>
          </div>
        )}

        {/* Connection Status */}
        <div className="bg-gray-700/50 p-4 rounded-lg">
          <div className="flex items-center gap-2 mb-2">
            <Wifi className={`w-5 h-5 ${navigator.onLine ? 'text-green-400' : 'text-red-400'}`} />
            <h3 className="font-medium text-white">Connection</h3>
          </div>
          <p className="text-white">{navigator.onLine ? 'Online' : 'Offline'}</p>
        </div>
      </div>
    </Modal>
  );
};